var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["savedSearchPopup", { error: _vm.hasError }] },
    [
      _c(
        "div",
        { class: ["savedSearchPopupContainer", { shown: _vm.isVisible }] },
        [
          _c("div", { staticClass: "topTabs" }, [
            _c(
              "span",
              {
                class: ["tab", "tabLeft", { active: _vm.tab === "history" }],
                on: { click: _vm.switchTabs },
              },
              [_vm._m(0), _vm._v(" "), _c("div", [_vm._v("Recent History")])]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: ["tab", "tabRight", { active: _vm.tab === "favorites" }],
                on: { click: _vm.switchTabs },
              },
              [_vm._m(1), _vm._v(" "), _c("div", [_vm._v("Saved Searches")])]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "closeButton", on: { click: _vm.handleClose } },
              [
                _c("i", {
                  staticClass: "fal fa-times-circle",
                  on: { click: _vm.handleClose },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _vm.tab === "history"
              ? _c("div", { staticClass: "historyTab" }, [
                  _c(
                    "ul",
                    { staticClass: "list historyDays" },
                    _vm._l(_vm.historyMap, function (historyList, day, index) {
                      return _c("li", { key: day }, [
                        _c("span", { staticClass: "dayDescription" }, [
                          _vm._v(_vm._s(day)),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "dayBreak" }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list historyEntries" },
                          _vm._l(historyList, function (history) {
                            return _c("li", { staticClass: "historyEntry" }, [
                              _c("span", { staticClass: "historyTime" }, [
                                _vm._v(
                                  _vm._s(_vm.calculateTime(history.created))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                directives: [
                                  {
                                    name: "dompurify-html",
                                    rawName: "v-dompurify-html",
                                    value: history.name,
                                    expression: "history.name",
                                  },
                                ],
                                staticClass: "historyName",
                                attrs: { title: "Enable" },
                                on: {
                                  click: function ($event) {
                                    return _vm.enableHistory(history)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "menuActivator" }, [
                                _c("i", {
                                  staticClass:
                                    "dropdown-toggle far fa-ellipsis-h",
                                  attrs: { "data-toggle": "dropdown" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    staticClass: "dropdown-menu",
                                    attrs: { role: "menu" },
                                  },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "border",
                                        on: {
                                          click: function ($event) {
                                            return _vm.enableHistory(history)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "far fa-plus-circle",
                                        }),
                                        _vm._v("Enable"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteHistory(history)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "far fa-trash-alt",
                                        }),
                                        _vm._v("Delete"),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.history.length >= _vm.getHistoryLimit()
                    ? _c("footer", { staticClass: "limitMessage footer" }, [
                        _vm._v("\n          Need more recent history? "),
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: "https://www.vyopta.com/product/cpm/how-to-buy/",
                            },
                          },
                          [_vm._v("See upgrade options")]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "favorites"
              ? _c("div", { staticClass: "favoritesTab" }, [
                  _c(
                    "ul",
                    { staticClass: "list favorites" },
                    [
                      _vm.isAdding &&
                      _vm.favorites.length < _vm.getFavoritesLimit()
                        ? _c("li", { staticClass: "favoriteEntry adding" }, [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newFavoriteName,
                                  expression: "newFavoriteName",
                                },
                              ],
                              attrs: { id: "addingInput", type: "text" },
                              domProps: { value: _vm.newFavoriteName },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.handleAdd.apply(null, arguments)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.newFavoriteName = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fas fa-check-circle",
                              on: { click: _vm.handleAdd },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAdding &&
                      _vm.favorites.length >= _vm.getFavoritesLimit()
                        ? _c("li", { staticClass: "favoriteEntry adding" }, [
                            _c(
                              "span",
                              { staticClass: "fullText alert alert-warning" },
                              [
                                _vm._v(
                                  "You have reached the saved search limit"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.currentFavorites, function (favorite, i) {
                        return _c(
                          "li",
                          {
                            key:
                              favorite.created.toString() + favorite.isEditing,
                            staticClass: "favoriteEntry",
                          },
                          [
                            _vm._m(3, true),
                            _vm._v(" "),
                            !favorite.isEditing
                              ? _c(
                                  "span",
                                  {
                                    key: favorite.isEditing,
                                    staticClass: "favoriteName",
                                    attrs: { title: "Enable" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.enableFavorite(favorite)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(favorite.name))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: favorite.isEditing,
                                  expression: "favorite.isEditing",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: favorite.name,
                                  expression: "favorite.name",
                                },
                              ],
                              ref: "editingInput" + i,
                              refInFor: true,
                              staticClass: "editingInput",
                              attrs: { type: "text" },
                              domProps: { value: favorite.name },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.handleRename(favorite)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    favorite,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            favorite.isEditing
                              ? _c("i", {
                                  staticClass: "fas fa-check-circle",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRename(favorite)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !favorite.isEditing
                              ? _c(
                                  "span",
                                  { staticClass: "menuActivator dropdown" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "dropdown-toggle far fa-ellipsis-h",
                                      attrs: { "data-toggle": "dropdown" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "dropdown-menu",
                                        attrs: { role: "menu" },
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "border",
                                            on: {
                                              click: function ($event) {
                                                return _vm.enableFavorite(
                                                  favorite
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-plus-circle",
                                            }),
                                            _vm._v("Enable"),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass: "border",
                                            on: {
                                              click: function ($event) {
                                                return _vm.renameFavorite(
                                                  favorite,
                                                  i
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-edit",
                                            }),
                                            _vm._v("Rename"),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteFavorite(
                                                  favorite
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt",
                                            }),
                                            _vm._v("Delete"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.favorites.length >= _vm.getFavoritesLimit()
                    ? _c("footer", { staticClass: "limitMessage footer" }, [
                        _vm._v("\n          Need more saved searches? "),
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: "https://www.vyopta.com/product/cpm/how-to-buy/",
                            },
                          },
                          [_vm._v("See upgrade options")]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "errorMessage" }, [
              _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      "),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("popup-wrapper", {
        class: { hidden: !_vm.isVisible },
        on: { "popup-mask-clicked": _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "far fa-history" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "far fa-book-heart" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "favoriteIcon" }, [
      _c("i", { staticClass: "fas fa-bookmark" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "favoriteIcon" }, [
      _c("i", { staticClass: "fal fa-bookmark" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }